import React from "react";
import ChartistGraph from "react-chartist";
import {
    Card,
    CardHeader,
    CardContent,
    Typography
} from "@material-ui/core";

function parseDateValue(value) {
    if (!value) return null;

    const str = String(value);

    const normalized = str.includes("T")
        ? str
        : str.replace(" ", "T") + "Z";

    const d = new Date(normalized);

    return Number.isNaN(d.getTime()) ? null : d;
}

function formatTime(value) {
    const d = parseDateValue(value);
    if (!d) return "";

    return d.toLocaleTimeString("de-DE", {
        timeZone: "Europe/Berlin",
        hour: "2-digit",
        minute: "2-digit"
    });
}

function normalizePrice(value) {
    if (value == null || value === "") return null;

    const parsed = Number(String(value).replace(",", "."));

    return Number.isFinite(parsed) ? parsed : null;
}

export default function SymbolChartCard({ signals }) {

    if (!signals || signals.length === 0) {
        return (
            <Card>
                <CardHeader title="Symbol-Chart" />
                <CardContent>
                    <Typography variant="body2">
                        Keine Alerts für diesen Tag vorhanden.
                    </Typography>
                </CardContent>
            </Card>
        );
    }

    // Zeit bestimmen
    const sorted = [...signals]
        .map(s => {

            const time =
                s.eventTime ||
                s.createdAt ||
                s.eventDate ||
                null;

            return {
                ...s,
                _time: parseDateValue(time),
                _price: normalizePrice(s.price)
            };

        })
        .filter(s => s._time && s._price != null)
        .sort((a, b) => a._time - b._time);


    if (sorted.length === 0) {
        return (
            <Card>
                <CardHeader title="Symbol-Chart" />
                <CardContent>
                    <Typography variant="body2">
                        Keine gültigen Zeit/Preis-Daten vorhanden.
                    </Typography>
                </CardContent>
            </Card>
        );
    }

    const labels = sorted.map(s => formatTime(s._time));

    const longSeries = sorted.map(s =>
        (s.direction === "LONG") ? s._price : null
    );

    const shortSeries = sorted.map(s =>
        (s.direction === "SHORT") ? s._price : null
    );

    const data = {
        labels,
        series: [
            longSeries,
            shortSeries
        ]
    };

    const options = {
        fullWidth: true,
        chartPadding: { right: 20 },
        showPoint: true,
        lineSmooth: false,
        axisX: {
            showGrid: false
        }
    };

    return (
        <Card>
            <CardHeader title="Symbol-Preis & Alerts" />

            <CardContent>

                <div style={{ height: 260 }}>
                    <ChartistGraph
                        data={data}
                        type="Line"
                        options={options}
                        listener={{
                            draw: function (data) {

                                if (data.type === "point") {

                                    if (data.seriesIndex === 0) {
                                        data.element._node.setAttribute(
                                            "style",
                                            "stroke:#4caf50; fill:#4caf50"
                                        );
                                    }

                                    if (data.seriesIndex === 1) {
                                        data.element._node.setAttribute(
                                            "style",
                                            "stroke:#f44336; fill:#f44336"
                                        );
                                    }
                                }
                            }
                        }}
                    />
                </div>

                <Typography variant="body2" style={{ marginTop: 8 }}>
                    ▲ LONG (grün) / ▼ SHORT (rot) – Preis zum Zeitpunkt des Alerts.
                </Typography>

            </CardContent>
        </Card>
    );
}